import { IAddress } from "interfaces/address.interface";
import cls from "./addressList.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import AddressCard from "components/addressCard/addressCard";
import "swiper/css";
import useModal from "hooks/useModal";
import React, { useState } from "react";
import dynamic from "next/dynamic";
import { useSettings } from "contexts/settings/settings.context";
import { useMediaQuery } from "@mui/material";
import { useDeleteAddress } from "hooks/useAddressServices";
import MapPinAddFillIcon from "remixicon-react/MapPinAddFillIcon";
import { useTranslation } from "react-i18next";

const AddressModal = dynamic(
  () => import("components/addressModal/addressModal"),
);

type Props = {
  data: IAddress[];
  withAddNewAddress?: boolean;
  selectedAddressId?: number;
  changeAddress: (item: IAddress) => void;
  onEditSelectedAddress?: () => void;
};

export default function AddressList({
  data = [],
  changeAddress,
  withAddNewAddress = true,
  selectedAddressId = 0,
  onEditSelectedAddress,
}: Props) {
  const { t } = useTranslation();
  const { location, address } = useSettings();
  const { mutate: deleteAddress } = useDeleteAddress();
  const isDesktop = useMediaQuery("(min-width:1000px)");
  const [isOpenModal, openModal, closeModal] = useModal();
  const [editAddress, setEditAddress] = useState<IAddress | null>(null);

  const localLocation = editAddress?.location?.join(",") || location;
  const localAddress = editAddress?.address?.address || address;

  const handleCloseModal = () => {
    closeModal();
    setEditAddress(null);
  };

  return (
    <>
      <div className={cls.container}>
        {withAddNewAddress && (
          <button
            type="button"
            className={cls.addAddressButton}
            onClick={(e) => {
              e.preventDefault();
              openModal();
            }}
          >
            <MapPinAddFillIcon size={28} />
            <span>{t("add.new.address")}</span>
          </button>
        )}
        <Swiper spaceBetween={12} slidesPerView="auto" className={cls.swiper}>
          {data?.map((item) => (
            <SwiperSlide key={item?.id} className={cls.swiperSlide}>
              <AddressCard
                data={item}
                changeAddress={changeAddress}
                onEdit={(address: IAddress) => {
                  setEditAddress(address);
                  openModal();
                }}
                onDelete={(id: number) => {
                  deleteAddress(id);
                }}
                isSelected={selectedAddressId === item?.id}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      {isOpenModal && (
        <AddressModal
          open={isOpenModal}
          onClose={handleCloseModal}
          latlng={localLocation}
          address={localAddress}
          fullScreen={!isDesktop}
          editedAddress={editAddress}
          onClearAddress={() => setEditAddress(null)}
          onEditSelectedAddress={onEditSelectedAddress}
        />
      )}
    </>
  );
}
